module.exports = __webpack_public_path__ + "static/media/mo.d0462262.png";